import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './StatusBadge.module.scss';

export const PENDING_STATUS_TOOLTIP =
  'Under review by the Twine Team, you will be notified once approved.';

let pendingTooltipId = 0;

const StatusBadge = ({ status, className }) => {
  const tooltipIdRef = useRef(null);
  const isClosed = status === 'expired' || status === 'inactive';
  const isPending = status === 'pending_approval';

  let badgeClass = styles.statusBadge;
  let displayText = status;

  if (isClosed) {
    badgeClass = `${styles.statusBadge} ${styles.statusClosed}`;
    displayText = 'closed';
  } else if (isPending) {
    badgeClass = `${styles.statusBadge} ${styles.statusPending}`;
    displayText = 'pending';
  } else if (status === 'active') {
    badgeClass = `${styles.statusBadge} ${styles.statusActive}`;
    displayText = 'active';
  } else if (status === 'open') {
    badgeClass = `${styles.statusBadge} ${styles.statusOpen}`;
    displayText = 'open';
  }

  const combinedClassName = [
    badgeClass,
    isPending ? styles.pendingTrigger : null,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const handlePendingActivate = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const badge = (
    <span
      className={combinedClassName}
      data-testid="status-badge"
      {...(isPending
        ? {
            tabIndex: 0,
            role: 'button',
            'aria-label': `pending. ${PENDING_STATUS_TOOLTIP}`,
            onClick: handlePendingActivate,
          }
        : {})}
    >
      {displayText.replace('_', ' ')}
    </span>
  );

  if (!isPending) {
    return badge;
  }

  if (tooltipIdRef.current === null) {
    pendingTooltipId += 1;
    tooltipIdRef.current = `pending-status-tooltip-${pendingTooltipId}`;
  }

  const body = typeof document !== 'undefined' ? document.body : undefined;

  return (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus', 'click']}
      rootClose
      container={body}
      overlay={
        <Tooltip id={tooltipIdRef.current} className={styles.pendingTooltip}>
          {PENDING_STATUS_TOOLTIP}
        </Tooltip>
      }
    >
      {badge}
    </OverlayTrigger>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default StatusBadge;
